var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("p", [
    _c("span", { staticStyle: { color: "red" } }, [
      _vm._v(_vm._s(_vm.item.id)),
    ]),
    _vm._v(" " + _vm._s(_vm.item.value) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }